import PublicLayout from "@/components/public/PublicLayout";
import { Card } from "@/components/ui/card";

export default function FAQ() {
  const items = [
    { q: "Is TheBillPro GST compliant?", a: "Yes. TheBillPro generates GST-ready tax invoices with CGST/SGST or IGST based on place of supply. HSN summary and tax reports are available for GSTR-1 and GSTR-3B preparation." },
    { q: "Can I use TheBillPro for my service business?", a: "Absolutely. TheBillPro handles both product and service catalogues. Interior designers, contractors, painters, electricians and other service providers use TheBillPro for quotations, invoicing and payment tracking." },
    { q: "Do I need to install anything?", a: "No. TheBillPro is a cloud application — it runs in your browser on desktop, tablet and mobile. Your data is securely stored online." },
    { q: "How much does TheBillPro cost?", a: "₹99/month for the core TheBillPro plan. A 14-day free trial is included so you can try before you subscribe." },
    { q: "Can I share invoices on WhatsApp?", a: "Yes. Every invoice, quotation and payment receipt can be shared via WhatsApp or email in one click." },
    { q: "Is my data safe?", a: "Yes. Data is encrypted in transit and stored on secure cloud infrastructure. Business data is never auto-deleted, even if you cancel your subscription." },
    { q: "Can I add multiple users?", a: "The TheBillPro plan includes 1 user. Higher plans support multiple users with roles like Owner, Admin, Accountant, Sales Staff, Purchase Staff and Viewer." },
    { q: "Which payment methods can I use to subscribe?", a: "UPI, Cards, NetBanking and Wallets via Razorpay. Payments are securely verified on our servers." },
  ];
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-heading text-4xl font-bold tracking-tight text-center">Frequently Asked Questions</h1>
        <p className="text-muted-foreground text-center mt-3">Everything you need to know about TheBillPro.</p>
        <div className="mt-10 space-y-3">
          {items.map((it) => (
            <Card key={it.q} className="p-5">
              <details className="group">
                <summary className="font-heading font-semibold cursor-pointer flex items-center justify-between">
                  {it.q}
                  <span className="text-muted-foreground group-open:rotate-180 transition-transform">▾</span>
                </summary>
                <p className="mt-3 text-muted-foreground text-sm leading-relaxed">{it.a}</p>
              </details>
            </Card>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
